import React, { useEffect } from 'react';
import SelectDropdown from "../../../../components/dropdown/selectdropdown/SelectDropdown";
import { useDispatch, useSelector } from "react-redux";
import Label from "../../../../components/label/Label";
import commonStyles from "../../FormSection.styles"
import RichGrid from "../../../../components/richgrid/RichGrid";
import { componentKey, setSelectedPayrollStatus, setSelectedPayrollState, setPayrollFormList, setSelectedPayrollForm, setSelectedPayrollTaxYear, setSelectedPayrollPayer, setPayrollPayerList, setSelectedStatePayrollFormsGrid, setPaginationState, setPayrollApproveFormsModal, setPayrollRejectFormsModal, setPayrollRejectFormRemark, setStatePayrollFormsGrid, setFormApprovalSuccess, setUrlStatusParam, setUrlFormIdParam, setUrlPayerIdParam } from '../statepayrollreviewapproveforms/StatePayrollReviewApproveFormsSlice';
import { getStatePayrollReviewAndApproveStatuses, getStatePayrollReviewAndApproveStates, getStatePayrollReviewAndApproveForms, getStatePayrollReviewAndApprovePayers, getreviewAndApproveGridData, statePayrollapproveForm, statePayrollrejectForm, viewStatePayrollReviewAndApproveFormPDF } from '../statepayrollreviewapproveforms/StatePayrollReviewApproveFormsSaga';
import ConfirmationPopup from '../../../../components/popup/confirmationpopup/ConfirmationPopup';
import useGarbageCollector from "../../../../../libs/garbagecollector/garbageCollectorHooks";
import { FORM_STATUS, REVIEW_APPROVE_FORMS_LOADING_STATES } from '../constants';
import useTxSearchParams from '../../../../../libs/txsearchparams/TxSearchParamsHook';
import { ROW_SELECTION_OPTIONS } from '../../../../components/richgrid/constants';
import Button from '../../../../components/button/Button';
import { addNotifications } from '../../../toaster/ToasterPortalSlice';
import { BUTTON_TYPE } from '../../../../components/button/constants';
import { LABEL_WEIGHT } from "../../../../components/label/constants";
import TextArea from '../../../../components/input/textarea/TextArea';
import { VEC_ICON_NAME } from '../../../../components/icons/constants';
import { REVIEW_AND_APPROVE_FORMS_LOADING_STATES, REVIEW_AND_APPROVE_FORMS_MESSAGE_MAP } from '../constants';
import { EDIT_FORM_ORIGIN, QUERY_PARAMS, FORM_SECTION_ROUTES } from '../../constants';
import { APPROVED_STATUS } from '../../formslisting/formslistingstatepayroll/constants';
import useTxNavigate from "../../../../../libs/txnavigate/TxNavigateHook";
import Loadable from '../../../../components/loadable/Loadable';
import General from '../../../../../libs/utility/General';
import Popup from '../../../../components/popup/Popup';
import Icons from '../../../../components/icons/Icons';

export default function StatePayrollForms() {

    useGarbageCollector(componentKey)

    const [queryParams, setQueryParams] = useTxSearchParams();

    const { loadingState, payrollStatusList, payrollSelectedStatus, payrollStateList, selectedPayrollState, payrollFormList, selectedPayrollForm, payrollTaxYearList, selectedPayrollTaxYear, payrollPayerList, selectedPayrollPayer, statePayrollFormsGrid, formApprovalSuccess, selectedStatePayrollForms, paginationState, payrollApproveFormsModal, payrollRejectFormsModal, payrollRejectFormRemark, urlFormIdParam, urlPayerIdParam, reloadGridData } = useSelector(state => state[componentKey]);
    const dispatch = useDispatch();
    const navigate = useTxNavigate();

    useEffect(() => {
        const urlStatus = queryParams.get(QUERY_PARAMS.STATUS);
        const stateParamFromUrl = queryParams.get(QUERY_PARAMS.STATE_ID)
        const formIdParamFromUrl = queryParams.get(QUERY_PARAMS.FORM_ID)
        const taxYearParamFromUrl = queryParams.get(QUERY_PARAMS.TAX_YEAR)
        const payerIdParamFromUrl = queryParams.get(QUERY_PARAMS.PAYER_ID)

        dispatch(setUrlStatusParam(urlStatus))
        dispatch(setUrlFormIdParam(formIdParamFromUrl))
        dispatch(setUrlPayerIdParam(payerIdParamFromUrl))

        dispatch(getStatePayrollReviewAndApproveStatuses({ status: urlStatus }));
        dispatch(getStatePayrollReviewAndApproveStates({ urlStateParam: stateParamFromUrl, urlTaxYearParam: taxYearParamFromUrl }));
    }, [])

    useEffect(() => {
        if (selectedPayrollState?.value) {
            dispatch(getStatePayrollReviewAndApproveForms({ stateNames: selectedPayrollState?.value, urlFormIdParam: urlFormIdParam }));
        } else {
            dispatch(setPayrollFormList([]));
        }
        dispatch(setSelectedPayrollForm({ label: "", value: "" }))
    }, [selectedPayrollState])

    useEffect(() => {
        if (selectedPayrollForm?.value) {
            dispatch(getStatePayrollReviewAndApprovePayers({ formId: selectedPayrollForm?.value, urlPayerIdParam: urlPayerIdParam }));
        }
        dispatch(setStatePayrollFormsGrid([]));
        dispatch(setSelectedStatePayrollFormsGrid([]));
        dispatch(setPayrollPayerList([]));
        dispatch(setSelectedPayrollPayer({ label: "", value: "" }))
    }, [selectedPayrollForm])

    useEffect(() => {
        if (reloadGridData) {
            if (payrollSelectedStatus?.value && selectedPayrollState?.value && selectedPayrollForm?.label && selectedPayrollTaxYear?.value && selectedPayrollPayer?.value) {
                dispatch(getreviewAndApproveGridData({
                    paginationState,
                    formId: selectedPayrollForm?.value,
                    taxyear: selectedPayrollTaxYear?.value,
                    payerId: selectedPayrollPayer?.value,
                    formstatus: payrollSelectedStatus?.status
                }))
            }
        }
    }, [reloadGridData])

    useEffect(() => {
        if (formApprovalSuccess) {
            const navigateUrl = `/${FORM_SECTION_ROUTES.FORMS}/${FORM_SECTION_ROUTES.LISTING}/${FORM_SECTION_ROUTES.STATEPAYROLL}?${QUERY_PARAMS.STATE_ID}=${selectedPayrollState?.value}&${QUERY_PARAMS.FORM_ID}=${selectedPayrollForm?.value}&${QUERY_PARAMS.TAX_YEAR}=${selectedPayrollTaxYear?.value}&${QUERY_PARAMS.PAYER_ID}=${selectedPayrollPayer?.value}&${QUERY_PARAMS.STATUS}=${APPROVED_STATUS.APPROVED}`;
            navigate(navigateUrl);
            dispatch(setFormApprovalSuccess(false));
        }
    }, [formApprovalSuccess])

    const STATE_PAYROLL_REVIEW_APPROVE_COLUMNS = [
        {
            field: "Date",
            header: <Label weight={LABEL_WEIGHT[700]} customStyles={{ ...commonStyles.text, ...commonStyles.date }}>Date</Label>,
            renderLogic: (row, idx) => <span style={{ ...commonStyles.text, ...commonStyles.date }}>{row?.Date || "-"}</span>
        },
        {
            field: "taxId",
            header: <Label weight={LABEL_WEIGHT[700]}>TIN</Label>,
            renderLogic: (row, idx) => <span style={{ ...commonStyles.text, ...commonStyles.date }}>{row?.TIN || "-"}</span>
        },
        {
            field: "payerName",
            header: <Label weight={LABEL_WEIGHT[700]}>Payer Name</Label>,
            renderLogic: (row, idx) => <span style={{ ...commonStyles.text, ...commonStyles.date }}>{row?.Name || "-"}</span>
        },
        {
            field: "email",
            header: <Label weight={LABEL_WEIGHT[700]}>User Email</Label>,
            renderLogic: (row, idx) => <span style={{ ...commonStyles.text, ...commonStyles.date }}>{row?.MemberEmail || "-"}</span>
        },
        {
            field: "Action",
            header: (
                <Label Label weight={LABEL_WEIGHT[700]}>
                    Action
                </Label>
            ),
            renderLogic: (row, idx) => (
                <div style={commonStyles.actionButtons}>
                    <Loadable
                        currentState={loadingState.state}
                        loadingStates={[`${REVIEW_AND_APPROVE_FORMS_LOADING_STATES.FETCHING_VIEW_PDF_LIST_LOADING}-${row?.FormId}`]}
                        messageMap={REVIEW_AND_APPROVE_FORMS_MESSAGE_MAP}
                        isNewLoadable={true}
                        isFullWidth={false}
                    >
                        <Button title={'View PDF'} style={commonStyles.buttonBackgroundWIcon} onClickCb={() => dispatch(viewStatePayrollReviewAndApproveFormPDF({
                            formId: row?.FormId,
                            payerId: selectedPayrollPayer?.value,
                            formTypeId: selectedPayrollForm?.FormId,
                            payerName: row?.Name,
                        }))}><Icons familyName={'vec'} iconName={VEC_ICON_NAME.VIEW_ICON} /></Button>
                    </Loadable>
                    {payrollSelectedStatus?.status != FORM_STATUS.APPROVED && <Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} title={'Edit'}
                        onClickCb={() => {
                            const queryObj = {
                                [QUERY_PARAMS.STATENAME]: selectedPayrollState?.value.toUpperCase(),
                                [QUERY_PARAMS.FORM_NAME]: selectedPayrollForm?.FormName1,
                                [QUERY_PARAMS.YEAR]: selectedPayrollTaxYear?.value,
                                [QUERY_PARAMS.FORM_RECORD_ID]: row?.FormId,
                                metaData: JSON.stringify({
                                    [EDIT_FORM_ORIGIN]: FORM_SECTION_ROUTES.REVIEW_AND_APPROVE_FORMS,
                                    [QUERY_PARAMS.STATUS]: payrollSelectedStatus?.status
                                })
                            }
                            const queryParamsStr = General.convertObjToQueryString(queryObj)

                            navigate(`/${FORM_SECTION_ROUTES.FORMS}/${[FORM_SECTION_ROUTES.CREATENEW]}?${queryParamsStr}`)
                        }}
                    >
                        <Icons familyName={'vec'} iconName={VEC_ICON_NAME.EDIT_ICON} />
                    </Button>}
                </div>
            ),
        },
    ]

    return (
        <Loadable currentState={loadingState.state} loadingStates={[REVIEW_AND_APPROVE_FORMS_LOADING_STATES.FETCHING_GRID_RECORDS_LOADING]} isNewLoadable={true}>
            <div style={commonStyles.dropdownContainer}>
                <div style={commonStyles.selectDropdown}>
                    <Loadable
                        currentState={loadingState.state}
                        loadingStates={[REVIEW_AND_APPROVE_FORMS_LOADING_STATES.FETCHING_STATUS_LIST_LOADING]}
                        messageMap={REVIEW_AND_APPROVE_FORMS_MESSAGE_MAP}
                        isNewLoadable={true}
                        isFullWidth={false}
                    >
                        <SelectDropdown
                            label="Status *"
                            name="Status"
                            placeHolder="Please select a status"
                            options={payrollStatusList}
                            value={payrollSelectedStatus}
                            onSelectCb={(name, selectedOption) => {
                                dispatch(setSelectedPayrollStatus(selectedOption));

                                if (selectedOption?.value) {
                                    queryParams.set(QUERY_PARAMS.STATUS, selectedOption?.value)
                                } else {
                                    queryParams.delete(QUERY_PARAMS.STATUS)
                                }
                                setQueryParams(queryParams);
                            }}
                        />
                    </Loadable>

                    <Loadable
                        currentState={loadingState.state}
                        loadingStates={[REVIEW_AND_APPROVE_FORMS_LOADING_STATES.FETCHING_STATES_LIST_LOADING]}
                        messageMap={REVIEW_AND_APPROVE_FORMS_MESSAGE_MAP}
                        isNewLoadable={true}
                        isFullWidth={false}
                    >
                        <SelectDropdown
                            label="State *"
                            name="State"
                            placeHolder="Please select a state"
                            options={payrollStateList}
                            value={selectedPayrollState}
                            onSelectCb={(name, selectedOption) => {
                                dispatch(setSelectedPayrollState(selectedOption));

                                if (selectedOption?.value) {
                                    queryParams.set(QUERY_PARAMS.STATE_ID, selectedOption?.value)
                                } else {
                                    queryParams.delete(QUERY_PARAMS.STATE_ID)
                                }
                                setQueryParams(queryParams);
                            }}
                        />
                    </Loadable>

                    <Loadable
                        currentState={loadingState.state}
                        loadingStates={[REVIEW_AND_APPROVE_FORMS_LOADING_STATES.FETCHING_FORMS_LIST_LOADING]}
                        messageMap={REVIEW_AND_APPROVE_FORMS_MESSAGE_MAP}
                        isNewLoadable={true}
                        isFullWidth={false}
                    >
                        <SelectDropdown
                            label="FormName *"
                            name="FormName"
                            placeHolder="Please select a form Name"
                            options={payrollFormList}
                            value={selectedPayrollForm}
                            onSelectCb={(name, selectedOption) => {
                                dispatch(setSelectedPayrollForm(selectedOption));

                                if (selectedOption?.value) {
                                    queryParams.set(QUERY_PARAMS.FORM_ID, selectedOption?.value)
                                } else {
                                    queryParams.delete(QUERY_PARAMS.FORM_ID)
                                }
                                setQueryParams(queryParams);
                            }}
                        />
                    </Loadable>


                    <SelectDropdown
                        label="TaxYear *"
                        name="TaxYear"
                        placeHolder="Please select a tax Year"
                        options={payrollTaxYearList}
                        value={selectedPayrollTaxYear}
                        onSelectCb={(name, selectedOption) => {
                            dispatch(setSelectedPayrollTaxYear(selectedOption));

                            if (selectedOption?.value) {
                                queryParams.set(QUERY_PARAMS.TAX_YEAR, selectedOption?.value)
                            } else {
                                queryParams.delete(QUERY_PARAMS.TAX_YEAR)
                            }
                            setQueryParams(queryParams);
                        }}
                    />

                    <Loadable
                        currentState={loadingState.state}
                        loadingStates={[REVIEW_AND_APPROVE_FORMS_LOADING_STATES.FETCHING_PAYERS_LIST_LOADING]}
                        messageMap={REVIEW_AND_APPROVE_FORMS_MESSAGE_MAP}
                        isNewLoadable={true}
                        isFullWidth={false}
                    >
                        <SelectDropdown
                            label="Payer *"
                            name="Payer"
                            placeHolder="Please select a payer"
                            options={payrollPayerList}
                            value={selectedPayrollPayer}
                            onSelectCb={(name, selectedOption) => {
                                dispatch(setSelectedPayrollPayer(selectedOption));

                                if (selectedOption?.value) {
                                    queryParams.set(QUERY_PARAMS.PAYER_ID, selectedOption?.value)
                                } else {
                                    queryParams.delete(QUERY_PARAMS.PAYER_ID)
                                }
                                setQueryParams(queryParams);
                            }}
                        />
                    </Loadable>

                    <Button
                        type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER}
                        onClickCb={() => {
                            if (payrollSelectedStatus?.value && selectedPayrollState?.value && selectedPayrollForm?.label && selectedPayrollTaxYear?.value && selectedPayrollPayer?.value) {
                                dispatch(getreviewAndApproveGridData({
                                    paginationState,
                                    formId: selectedPayrollForm?.value,
                                    taxyear: selectedPayrollTaxYear?.value,
                                    payerId: selectedPayrollPayer?.value,
                                    formstatus: payrollSelectedStatus?.status
                                }))
                            } else {
                                dispatch(addNotifications({ heading: "Error", message: "Please select status, state, form, tax year and payer" }))
                            }
                        }
                        }>Search</Button>
                </div>
            </div>

            {statePayrollFormsGrid.length ? <div style={commonStyles.buttonContainer}>

                {payrollSelectedStatus?.status !== FORM_STATUS.APPROVED && <Button
                    style={commonStyles.button}
                    onClickCb={() => {
                        if (selectedStatePayrollForms.length) {
                            dispatch(setPayrollApproveFormsModal(true))
                        } else {
                            dispatch(addNotifications({ heading: "Error", message: "Please select recipient details to Approve Form" }))
                        }
                    }}>
                    Approve Form
                </Button>}

                {payrollSelectedStatus?.status !== FORM_STATUS.REJECTED && <Button
                    style={commonStyles.button}
                    onClickCb={() => {
                        if (selectedStatePayrollForms.length) {
                            dispatch(setPayrollRejectFormsModal(true))
                        } else {
                            dispatch(addNotifications({ heading: "Error", message: "Please select recipient details to Reject Form" }))
                        }
                    }}>Reject Form</Button>}
            </div> : null}

            <Loadable
                currentState={loadingState.state}
                loadingStates={[REVIEW_AND_APPROVE_FORMS_LOADING_STATES.FETCHING_GRID_RECORDS_LOADING]}
                messageMap={REVIEW_AND_APPROVE_FORMS_MESSAGE_MAP}
                isNewLoadable={true}
            >
                <RichGrid
                    selectable={true}
                    data={statePayrollFormsGrid}
                    columns={STATE_PAYROLL_REVIEW_APPROVE_COLUMNS}
                    extractRowKey={(row) => row.FormId}
                    selectedRows={selectedStatePayrollForms}
                    onHeaderSelectionChangeCallBack={(selectedData) => dispatch(setSelectedStatePayrollFormsGrid(selectedData))}
                    onSelectionChangeCallBack={(selectedData) => dispatch(setSelectedStatePayrollFormsGrid(selectedData))}
                    paginationProps={{
                        skip: paginationState?.Skip,
                        take: paginationState?.PageSize,
                        takeOptions: ROW_SELECTION_OPTIONS,
                        total: paginationState?.total,
                        onChangeTakeCb: (newTake) => {
                            dispatch(setPaginationState({ ...paginationState, PageSize: newTake, PageNumber: 1, Skip: 0 }));
                        },
                        onChange: (take, skip) => {
                            dispatch(setPaginationState({ ...paginationState, PageSize: take, Skip: skip, PageNumber: Math.ceil((take + skip) / take) }))
                        }
                    }}
                />
            </Loadable>


            {payrollApproveFormsModal &&
                <ConfirmationPopup
                    bodyText={"Would you like to submit these forms now?"}
                    isOpen={payrollApproveFormsModal}
                    confirmationButtonProps={{
                        onConfirmationCb: () => dispatch(setPayrollApproveFormsModal(false)),
                        confirmationButtonText: "Cancel",
                        confirmationButtonStyles: {},
                        confirmationButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                    }}
                    cancelButtonProps={{
                        onCancelCb: () => dispatch(statePayrollapproveForm({
                            formIds: selectedStatePayrollForms.map(f => f.FormId).toString(),
                            payerId: selectedPayrollPayer?.value,
                            formName: selectedPayrollForm?.FormName1,
                            payerName: selectedPayrollPayer?.LastName,
                            taxyear: selectedPayrollTaxYear?.value,
                            paginationState,
                            formId: selectedPayrollForm?.value,
                            formstatus: payrollSelectedStatus?.status
                        })),
                        cancelButtonText: "Ok",
                        cancelButtonStyles: {},
                        cancelButtonType: BUTTON_TYPE.PRIMARY,
                    }}
                    showClose={false}
                />
            }


            {payrollRejectFormsModal &&
                <Popup
                    title="Notes"
                    isPopupOpen={payrollRejectFormsModal}
                    customPopupHeaderStyles={commonStyles.modalHeaderWTextArea}
                    childrenStyles={commonStyles.modalBodyWTextArea}
                    onCloseCb={() => dispatch(setPayrollRejectFormsModal(false))}
                >
                    <Loadable currentState={loadingState?.state} messageMap={REVIEW_AND_APPROVE_FORMS_MESSAGE_MAP} loadingStates={[REVIEW_APPROVE_FORMS_LOADING_STATES.REJECT_FORM_LOADING]} isNewLoadable={true}>
                        <TextArea value={payrollRejectFormRemark} onChangeCb={(e) => dispatch(setPayrollRejectFormRemark(e.target.value))} rows={10} placeholder="Enter Remarks (Optional)" />

                        <Button style={commonStyles.okButton} onClickCb={() =>
                            dispatch(statePayrollrejectForm({
                                formIds: selectedStatePayrollForms.map(f => f.FormId).toString(),
                                payerId: selectedPayrollPayer?.value,
                                formName: selectedPayrollForm?.FormName1,
                                payerName: selectedPayrollPayer?.LastName,
                                taxyear: selectedPayrollTaxYear?.value,
                                remarks: payrollRejectFormRemark,
                                paginationState,
                                formId: selectedPayrollForm?.value,
                                formstatus: payrollSelectedStatus?.status
                            }))
                        }>Ok</Button>
                        <Button style={commonStyles.cancelButton} type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} onClickCb={() => dispatch(setPayrollRejectFormsModal(false))}>Cancel</Button>
                    </Loadable>
                </Popup>
            }
        </Loadable>
    )
}